<template>
  <div>
    <v-dialog v-model="isAdding" title="Add a transaction" width="500px">
      <v-card>
        <v-card-title class="primary white--text d-flex justify-space-between">
          <span>Start A New Crypto Transaction</span>
          <v-btn text icon dark @click="isAdding = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-container>
          <create-transaction-form @transactionCreated="transactionCreated" />
        </v-container>
      </v-card>
    </v-dialog>

    <data-table
      ref="table"
      :headers="headers"
      :url="url"
      :csv="true"
      csvFileName="crypto_transactions.csv"
      :csvFields="csvFields"
      title="Transactions"
      item-key="id"
      :fields="fields"
      searchable
      @click:row="showDetails"
    >
      <v-btn slot="action.icons" color="primary" tile @click="isAdding = true">
        <v-icon>mdi-plus</v-icon>
        New Transaction
      </v-btn>
      <template slot="action.top">
        <v-row>
          <v-col cols="12" md="2" class="d-flex ml-4 align-center">
            <h2 class="subtitle-2 text-uppercase">Remaining Balance</h2>
          </v-col>
          <v-col cols="12" md="2" v-for="(balance, index) in coinbaseBal" :key="index">
            <span class="font-weight-bold primary--text display-1">
              {{
                new Intl.NumberFormat("de-DE", {
                  style: "currency",
                  currency: balance.currency,
                }).format(balance.balance)
              }}</span
            >
          </v-col>
          <v-col cols="12" md="2"> </v-col>
        </v-row>
      </template>
      <template slot="item.status" slot-scope="{ item }">
        <v-icon v-if="item.crypto_sending_status === 'completed'" color="success">
          mdi-progress-check
        </v-icon>
        <v-icon color="error" v-else-if="item.crypto_sending_status === 'failed'"
          >mdi-progress-close</v-icon
        >
        <v-icon v-else color="warning">mdi-information-outline</v-icon>
      </template>
      <template slot="item.action" slot-scope="{ item }">
        <verify-transaction :dataTransaction="item" @updated="$refs.table.replaceItem($event)" />
      </template>
    </data-table>
  </div>
</template>

<script>
import CreateTransactionForm from "./cryptoTransactionForm";
import VerifyTransaction from "./Verifier";
import CoinbaseBalance from "./fetchCoinbaseBalance";

export default {
  components: { VerifyTransaction, CreateTransactionForm },
  props: {
    url: {
      type: String,
      required: true,
    },
    showUserDetails: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [CoinbaseBalance],
  data() {
    return {
      isAdding: false,
      commonHeaders: this.pairTableLabelWithValue({
        Date: "created_at",
        Id: "id",
        "Local Amount": "local_amount",
        Status: "status",
      }),
      fields: {
        "crypto_currency.name": { type: "title" },
        local_amount: { type: "currency" },
      },
      csvFields: [
        {
          label: "User Full Name",
          value: "user.full_name",
          default: "",
        },
        {
          label: "User Phone Number",
          value: "user.full_phone_number",
          default: "",
        },
        {
          label: "Order Status",
          value: "order_status",
          default: "",
        },
        {
          label: "Crypto Sending Status",
          value: "crypto_sending_status",
          default: "",
        },
        {
          label: "Crypto Address",
          value: "address",
          default: "",
        },
        {
          label: "Ref to Local at init",
          value: "reference_to_local_rate_at_init",
          default: "",
        },
        {
          label: "Ref to Local at start",
          value: "reference_to_local_rate_at_start",
          default: "",
        },
        {
          label: "Amount in ref currency",
          // eslint-disable-next-line no-unused-vars
          value: function (row, field, data) {
            // field = { label, default }
            // data = full data object

            let amount = row.local_amount / row.reference_to_local_rate_at_start;
            amount = Number(amount).toLocaleString("de-DE");
            return amount + " " + row.reference_currency.short_name.toUpperCase();
          },
          default: "",
        },
        {
          label: "Amount in local currency",
          // eslint-disable-next-line no-unused-vars
          value: function (row, field, data) {
            // field = { label, default }
            // data = full data object
            return row.local_amount + " " + row.local_currency.short_name.toUpperCase();
          },
          default: "",
        },
        {
          label: "Crypto value",
          // eslint-disable-next-line no-unused-vars
          value: function (row, field, data) {
            // field = { label, default }
            // data = full data object
            const value = !row.value
              ? null
              : Number(row.value).toLocaleString("de-DE", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 5,
                });
            return !value ? " " : value + " " + row.crypto_currency.short_name.toUpperCase();
          },
          default: "",
        },
        {
          label: "Crypto to ref currency rate",
          value: "reference_to_crypto_rate_at_verify",
          default: "",
        },
        {
          label: "Created At",
          value: "created_at",
          default: "",
        },
        {
          label: "Started At",
          value: "verified_at",
          default: "",
        },
      ],
    };
  },
  created() {
    //this.getCoinbaseBal();
  },
  computed: {
    headers() {
      if (this.showUserDetails) {
        return [
          {
            text: "User",
            value: "user.full_name",
          },
          {
            text: "Phone number",
            value: "user.full_phone_number",
          },
          {
            text: "Crypto Country",
            value: "crypto_country.name",
          },
          {
            text: "Crypto Address",
            value: "address",
          },
        ].concat(this.commonHeaders);
      }
      return this.commonHeaders;
    },
  },

  methods: {
    transactionCreated({ message, transaction }) {
      this.isAdding = false;
      window.Notify.success(message);
      this.showDetails(transaction);
    },
    showDetails({ id }) {
      this.$router.push({ name: "crypto.transactions.show", params: { id } });
    },
  },
};
</script>
